import { render, staticRenderFns } from "./TChip.vue?vue&type=template&id=01ca122c&scoped=true&"
import script from "./TChip.vue?vue&type=script&lang=js&"
export * from "./TChip.vue?vue&type=script&lang=js&"
import style0 from "./TChip.vue?vue&type=style&index=0&id=01ca122c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca122c",
  null
  
)

export default component.exports